import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { TranslocoService } from "@jsverse/transloco";
import { environment } from "src/environments/environment";
import { RaceBackend } from "../backend/api/race.backend";
import { Race } from "../backend/models/race/race";

@Injectable()
export class ProvideBreedGuard {
  constructor(
    private raceBackend: RaceBackend,
    private translocoService: TranslocoService
  ) {}

  async canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<boolean> {
    try {
      const breedLists = await Promise.all(
        environment.snoots.species.map((specie: string) =>
          this.raceBackend.list(specie).toPromise()
        )
      );

      breedLists.forEach((list: Race[]) => {
        const map = list.reduce<Record<string, string>>(
          (previousValue, currentValue) => {
            previousValue[currentValue.key] = currentValue.value;
            return previousValue;
          },
          {}
        );

        this.translocoService.setTranslation(map, "it", { merge: true });
      });
      return true;
    } catch (ex) {
      console.error(ex);
      return false;
    }
  }
}
